var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LoaderImage } from "@/utils/loader";
import { faWrench } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
var Upgrade = function () {
    var t = useTranslation(["Administration"]).t;
    var _a = useState(false), isLoading = _a[0], setIsLoading = _a[1];
    var navigate = useNavigate();
    var quickRepair = function (action, type) {
        if (type === void 0) { type = ""; }
        if (type) {
            navigate("repair/".concat(action, "/").concat(type));
        }
        else {
            navigate("repair/".concat(action));
        }
    };
    var repairItems = [
        {
            onClick: function () { return quickRepair("clearAll"); },
            label: t("LBL_QUICK_REPAIR_AND_REBUILD"),
            desc: t("LBL_QUICK_REPAIR_AND_REBUILD_DESC"),
        },
        {
            onClick: function () { return quickRepair("expandDatabase"); },
            label: t("LBL_EXPAND_DATABASE_COLUMNS"),
            desc: t("LBL_EXPAND_DATABASE_COLUMNS_DESC"),
        },
        {
            onClick: function () { return quickRepair("upgradeAccess"); },
            label: t("LBL_REBUILD_HTACCESS"),
            desc: t("LBL_REBUILD_HTACCESS_DESC"),
        },
        {
            onClick: function () { return quickRepair("rebuildConfig"); },
            label: t("LBL_REBUILD_CONFIG"),
            desc: t("LBL_REBUILD_CONFIG_DESC"),
        },
        {
            onClick: function () { return quickRepair("rebuildModuleRelationships"); },
            label: t("LBL_REBUILD_REL_TITLE"),
            desc: t("LBL_REBUILD_REL_DESC"),
        },
        {
            onClick: function () { return quickRepair("rebuildSchedulers"); },
            label: t("LBL_REBUILD_SCHEDULERS_TITLE"),
            desc: t("LBL_REBUILD_SCHEDULERS_DESC_SHORT"),
        },
        {
            onClick: function () { return quickRepair("rebuildDashlets"); },
            label: t("LBL_REBUILD_DASHLETS_TITLE"),
            desc: t("LBL_REBUILD_DASHLETS_DESC"),
        },
        {
            onClick: function () { return quickRepair("rebuildJSLang"); },
            label: t("LBL_REBUILD_JAVASCRIPT_LANG_TITLE"),
            desc: t("LBL_REBUILD_JAVASCRIPT_LANG_DESC_SHORT"),
        },
        {
            onClick: function () { return quickRepair("repairJSFile", "replace"); },
            label: t("LBL_REBUILD_JS_FILES_TITLE"),
            desc: t("LBL_REBUILD_JS_FILES_DESC_SHORT"),
        },
        {
            onClick: function () { return quickRepair("repairJSFile", "concat"); },
            label: t("LBL_REBUILD_CONCAT_JS_FILES_TITLE"),
            desc: t("LBL_REBUILD_CONCAT_JS_FILES_DESC_SHORT"),
        },
        {
            onClick: function () { return quickRepair("repairJSFile", "mini"); },
            label: t("LBL_REBUILD_JS_MINI_FILES_TITLE"),
            desc: t("LBL_REBUILD_JS_MINI_FILES_DESC_SHORT"),
        },
        {
            onClick: function () { return quickRepair("repairFieldCasing"); },
            label: t("LBL_REPAIR_FIELD_CASING_TITLE"),
            desc: t("LBL_REPAIR_FIELD_CASING_DESC_SHORT"),
        },
        {
            onClick: function () { return quickRepair("repairRoles"); },
            label: t("LBL_REPAIR_ROLES"),
            desc: t("LBL_REPAIR_ROLES_DESC"),
        },
        {
            onClick: function () { return quickRepair("repairIE"); },
            label: t("LBL_REPAIR_IE"),
            desc: t("LBL_REPAIR_IE_DESC"),
        },
        /*{
          onClick: () => navigate("/modules/Administration/Upgrade/repairXSS"),
          label: t("LBL_REPAIR_XSS"),
          desc: t("LBL_REPAIRXSS_TITLE"),
        },*/
        {
            onClick: function () { return quickRepair("repairActivities"); },
            label: t("LBL_REPAIR_ACTIVITIES"),
            desc: t("LBL_REPAIR_ACTIVITIES_DESC"),
        },
        {
            onClick: function () {
                return navigate("/modules/Administration/Upgrade/repairSeedUsers");
            },
            label: t("LBL_REPAIR_SEED_USERS_TITLE"),
            desc: t("LBL_REPAIR_SEED_USERS_DESC"),
        },
        {
            onClick: function () { return quickRepair("repairUploadFolder"); },
            label: t("LBL_REPAIR_UPLOAD_FOLDER"),
            desc: t("LBL_REPAIR_UPLOAD_FOLDER_DESC"),
        },
    ];
    return (_jsx("div", __assign({ className: "repair rounded p-2", style: { overflow: "auto" } }, { children: _jsxs("div", __assign({ className: "content" }, { children: [_jsx("h1", __assign({ className: "title is-4 p-3 text-[rgb(var(--color-gray-600))]", style: { textTransform: "uppercase" } }, { children: t("LBL_REPAIR") })), _jsx("div", __assign({ className: "columns" }, { children: _jsxs("div", __assign({ className: "column" }, { children: [isLoading && _jsx(LoaderImage, {}), _jsx("table", __assign({ className: "w-full bg-white rounded-md" }, { children: _jsx("tbody", { children: repairItems.map(function (item, index) { return (_jsxs("tr", __assign({ className: "border-b" }, { children: [_jsx("td", __assign({ className: "pr-4 pl-2" }, { children: _jsx(FontAwesomeIcon, { className: "text-[rgb(var(--color-gray-500))]", icon: faWrench }) })), _jsx("td", __assign({ className: "py-2 text-sm" }, { children: _jsx("a", __assign({ className: "text-[rgb(var(--color-blue-700))] cursor-pointer", onClick: item.onClick }, { children: item.label })) })), _jsx("td", __assign({ className: "text-sm text-[rgb(var(--color-gray-700))]" }, { children: item.desc }))] }), index)); }) }) }))] })) }))] })) })));
};
export default Upgrade;
